import React, { createContext, useContext, useState } from "react"

type PromobarContentType = React.ReactNode | string | null
type PromobarVisibilityType = boolean
type PromobarCoveBannerHrefType = string | undefined
type PromobarContextType = {
  promobarContent: PromobarContentType
  setPromobarContent: (value: PromobarContentType) => void
  promobarVisibility: boolean
  setPromobarVisibility: (value: PromobarVisibilityType) => void
  promobarCoveBannerHref: PromobarCoveBannerHrefType
  setPromobarCoveBannerHref: (value: PromobarCoveBannerHrefType) => void
}

const defaultValue = {
  promobarContent: null,
  setPromobarContent: () => null,
  promobarVisibility: true,
  setPromobarVisibility: () => true,
  promobarCoveBannerHref: undefined,
  setPromobarCoveBannerHref: () => null
}

export const PromobarContext = createContext<PromobarContextType>(defaultValue)

export const PromobarProvider: React.FC = ({ children }) => {
  const [promobarContent, setPromobarContent] = useState<PromobarContentType>(defaultValue.promobarContent)
  const [promobarVisibility, setPromobarVisibility] = useState<PromobarVisibilityType>(defaultValue.promobarVisibility)
  const [promobarCoveBannerHref, setPromobarCoveBannerHref] = useState<PromobarCoveBannerHrefType>(
    defaultValue.promobarCoveBannerHref
  )

  return (
    <PromobarContext.Provider
      value={{
        promobarContent,
        setPromobarContent,
        promobarVisibility,
        setPromobarVisibility,
        promobarCoveBannerHref,
        setPromobarCoveBannerHref
      }}
    >
      {children}
    </PromobarContext.Provider>
  )
}

export const usePromobar = () => useContext(PromobarContext)
